import { actionGenerator } from "utils";
import {
  VALIDATE_CODE,
  REQUEST_OTP,
  VERIFY_OTP,
  OTP_LOG,
  REQUEST_LOGIN,
  UPDATE_USER_INFO,
  REQUEST_GIGYA,
  EXCHANGE_CODE,
  TOPUP_MOBILE,
  VALIDATE_CAMPAIGN,
  CHECK_TRANSACTION_ID,
  GENERATE_TRANSACTION_ID,
  CHECK_PHONE_NUMBER,
  RECEIVED_REPORT,
  UPDATE_HOME_STATE,
} from "./constants";

const actions = {
  VALIDATE_CODE: actionGenerator.genActions(VALIDATE_CODE),
  VALIDATE_CAMPAIGN: actionGenerator.genActions(VALIDATE_CAMPAIGN),
  REQUEST_OTP: actionGenerator.genActions(REQUEST_OTP),
  OTP_LOG: actionGenerator.genActions(OTP_LOG),
  VERIFY_OTP: actionGenerator.genActions(VERIFY_OTP),
  REQUEST_LOGIN: actionGenerator.genActions(REQUEST_LOGIN),
  UPDATE_USER_INFO: actionGenerator.genActions(UPDATE_USER_INFO),
  REQUEST_GIGYA: actionGenerator.genActions(REQUEST_GIGYA),
  EXCHANGE_CODE: actionGenerator.genActions(EXCHANGE_CODE),
  TOPUP_MOBILE: actionGenerator.genActions(TOPUP_MOBILE),
  //new
  CHECK_TRANSACTION_ID: actionGenerator.genActions(CHECK_TRANSACTION_ID),
  GENERATE_TRANSACTION_ID: actionGenerator.genActions(GENERATE_TRANSACTION_ID),
  CHECK_PHONE_NUMBER: actionGenerator.genActions(CHECK_PHONE_NUMBER),
  RECEIVED_REPORT: actionGenerator.genActions(RECEIVED_REPORT),
  UPDATE_HOME_STATE: actionGenerator.genActions(UPDATE_HOME_STATE),
};

export default actions;
